module.exports = __webpack_public_path__ + "be919cba6e98fb06f640d1ed955afd85.pdf";